// extracted by mini-css-extract-plugin
module.exports = {"container":"_33974c2b58--container--MknCw","container--size-m":"_33974c2b58--container--size-m--X9dbp"};